import axios from 'axios';
import { pickBy } from 'lodash';
import qs from 'qs';
import { FSC_SOURCE, FUEL_SURCHARGE_TYPE } from 'constants/fsc/fsc';
import client from './rest/AdminClient';
export const fscPeriodType = {
    CURRENT: 'current',
    UPCOMING: 'upcoming',
    EXPIRED: 'expired',
};
let isNewFscFlowCached = null;
export const createFscSettings = async (data, overrideIntersecting = false) => {
    var _a, _b, _c;
    try {
        const res = await client({
            method: 'POST',
            path: `/api/v2/fsc-configs?overrideIntersecting=${overrideIntersecting}`,
            entity: JSON.stringify(pickBy(data, (value) => value)),
        });
        return (_a = res.entity) === null || _a === void 0 ? void 0 : _a.fscConfig;
    }
    catch (e) {
        let message;
        if ((_b = e === null || e === void 0 ? void 0 : e.entity) === null || _b === void 0 ? void 0 : _b.error) {
            const splitted = (_c = e === null || e === void 0 ? void 0 : e.entity) === null || _c === void 0 ? void 0 : _c.error.split(':');
            message = splitted[splitted.length - 1];
        }
        else {
            message = e === null || e === void 0 ? void 0 : e.message;
        }
        throw new Error(message);
    }
};
export const getFscSettingsById = async (id) => {
    var _a;
    try {
        const response = await client({
            method: 'GET',
            path: `/api/v2/fsc-configs/${id}`,
        });
        return mapEntityToModel(response === null || response === void 0 ? void 0 : response.entity);
    }
    catch (e) {
        throw new Error(((_a = e.entity) === null || _a === void 0 ? void 0 : _a.error) || e.message);
    }
};
export const getFscSettings = async (accountId, fscPeriodType, { perPage = 1000, skip, orderType } = {}) => {
    var _a, _b;
    try {
        const query = { accountId, fscPeriodType, perPage, skip, orderType };
        const response = await client({
            method: 'GET',
            path: `/api/v2/fsc-configs?${qs.stringify(query)}`,
        });
        return Object.assign(Object.assign({}, response === null || response === void 0 ? void 0 : response.entity), { rows: (_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.rows.map((r) => mapEntityToModel(r)) });
    }
    catch (e) {
        throw new Error(((_b = e.entity) === null || _b === void 0 ? void 0 : _b.error) || e.message);
    }
};
export const updateFscSettings = async (id, data, overrideIntersecting = false) => {
    var _a, _b, _c;
    try {
        const res = await client({
            method: 'PUT',
            path: `/api/v2/fsc-configs/${id}?overrideIntersecting=${overrideIntersecting}`,
            entity: JSON.stringify(pickBy(data, (value) => value)),
        });
        return (_a = res.entity) === null || _a === void 0 ? void 0 : _a.fscConfig;
    }
    catch (e) {
        let message;
        if ((_b = e === null || e === void 0 ? void 0 : e.entity) === null || _b === void 0 ? void 0 : _b.error) {
            const splitted = (_c = e === null || e === void 0 ? void 0 : e.entity) === null || _c === void 0 ? void 0 : _c.error.split(':');
            message = splitted[splitted.length - 1];
        }
        else {
            message = e === null || e === void 0 ? void 0 : e.message;
        }
        throw new Error(message);
    }
};
export const deleteFscSettings = (id) => client({
    method: 'DELETE',
    path: `/api/v2/fsc-configs/${id}`,
});
export const getCargomaticFscConfigTemplate = async (accountType) => {
    const url = `${PRICING_SERVICE_HOST}/fsc-configs/templates?source=${FSC_SOURCE.CARGOMATIC}&fuelSurchargeType=${FUEL_SURCHARGE_TYPE.PERCENT}&accountType=${accountType}`;
    const options = {
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': PRICING_SERVICE_API_KEY,
        },
    };
    const response = await axios(options);
    if (response.status !== 200) {
        throw new Error(`Error while getting cargomatic fsc config template for account type ${accountType}`);
    }
    const { data } = response;
    return data;
};
export const getFscSettingAudits = async (accountId, page = 1, perPage = 100) => {
    var _a, _b;
    try {
        const skip = (page - 1) * perPage;
        const query = { accountId, skip, perPage };
        const response = await client({
            method: 'GET',
            path: `/api/v2/fsc-configs/audit?${qs.stringify(query)}`,
        });
        return ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.rows) || [];
    }
    catch (e) {
        throw new Error(((_b = e.entity) === null || _b === void 0 ? void 0 : _b.error) || e.message);
    }
};
export const getIsNewFscFlow = async () => {
    var _a, _b;
    if (isNewFscFlowCached !== null) {
        return isNewFscFlowCached;
    }
    try {
        const response = await client({
            method: 'GET',
            path: '/api/v2/is-new-fsc-flow',
        });
        isNewFscFlowCached = (_a = response.entity) === null || _a === void 0 ? void 0 : _a.isNewFscFlow;
        return isNewFscFlowCached;
    }
    catch (e) {
        throw new Error(((_b = e.entity) === null || _b === void 0 ? void 0 : _b.error) || e.message);
    }
};
const mapEntityToModel = (data) => (Object.assign(Object.assign({}, data), { importAnchorEvent: data.anchorEventImport, exportAnchorEvent: data.anchorEventExport, repositionAnchorEvent: data.anchorEventReposition, fuelPriceMin: data.matrixFuelPriceMin, fuelPriceMax: data.matrixFuelPriceMax, fuelPriceStepInterval: data.matrixFuelPriceStepInterval, fscMin: data.matrixFscMinPercent || data.matrixFscMinCostPerMile, fscStepInterval: data.matrixFscPercentStepInterval || data.matrixFscCostPerMileStepInterval }));
